'use strict';

exports.__esModule = true;
var ACTIVITIES = exports.ACTIVITIES = {
  ACTIVITIES_RESERVATION: {
    LOAD: 'ACTIVITIES_RESERVATION_LOAD',
    SUCCESS: 'ACTIVITIES_RESERVATION_LOAD_SUCCESS',
    FAIL: 'ACTIVITIES_RESERVATION_LOAD_FAIL',
    RESET: 'ACTIVITIES_RESERVATION_RESET'
  }
};

var getActivitiesReservations = exports.getActivitiesReservations = function getActivitiesReservations(payload) {
  return {
    type: ACTIVITIES.ACTIVITIES_RESERVATION.LOAD,
    payload: payload
  };
};

var getActivitiesReservationsSuccess = exports.getActivitiesReservationsSuccess = function getActivitiesReservationsSuccess(payload) {
  return {
    type: ACTIVITIES.ACTIVITIES_RESERVATION.SUCCESS,
    payload: payload
  };
};

var getActivitiesReservationsFail = exports.getActivitiesReservationsFail = function getActivitiesReservationsFail(payload) {
  return {
    type: ACTIVITIES.ACTIVITIES_RESERVATION.FAIL,
    payload: payload
  };
};

var resetActivitiesList = exports.resetActivitiesList = function resetActivitiesList() {
  return {
    type: ACTIVITIES.ACTIVITIES_RESERVATION.RESET
  };
};